module.exports = {
  "categories": [
    {
      "name": "personal",
      "label": "Personal",
      "link": "/category/personal",
    },
    {
      "name": "finance",
      "label": "Finance",
      "link": "/category/finance",
    },
    {
      "name": "programming",
      "label": "Programming",
      "link": "/category/programming",
    }
  ]
}
